<script>
import { formatter } from '@/helpers/formatter'
export default {
  mixins: [formatter],
  props: {
    value: {
      type: Number
    }
  },
  computed: {
    slotValue() {
      return this.$slots.default
        ? this.formatCurrency(this.$slots.default[0].text)
        : this.formatCurrency(this.value)
    }
  }
}
</script>
<template>
  <div class="d-inline">
    <slot v-if="!$slots.default" :currencyValue="slotValue"></slot>
    <template v-else>
      {{ slotValue }}
    </template>
  </div>
</template>
